// src/components/WelcomeScreen.js
import React, { useState, useEffect } from 'react';
import { Mic, Hand, Volume2 } from 'lucide-react';
import 'bulma/css/bulma.min.css';
import './WelcomeScreen.css';

const WelcomeScreen = ({ onNext }) => {
  const [greeting, setGreeting] = useState('');
  const [isListening, setIsListening] = useState(false);

  useEffect(() => {
    const hour = new Date().getHours();
    if (hour < 12) setGreeting('Good Morning!');
    else if (hour < 17) setGreeting('Good Afternoon!');
    else setGreeting('Good Evening!');
  }, []);

  const handleVoiceStart = () => {
    setIsListening(true);
    setTimeout(() => {
      setIsListening(false);
      onNext();
    }, 3000);
  };

  return (
    <div className="welcome-screen">

      {/* Animated Background Elements */}
      <div className="bg-element bg-element-1" />
      <div className="bg-element bg-element-2" />

      {/* Header Section */}
      <div className="welcome-header has-text-centered">
        {/* Logo */}
        <div className="heysalad-logo">
          <img src="/HeySalad Logo White.png" alt="HeySalad" className="logo-image" />
        </div>

        {/* Greeting */}
        <h1 className="greeting-text">
          {greeting}
        </h1>

        <h2 className="subtitle-text">
          Fall in love with cooking again
        </h2>
      </div>

      {/* Interactive Buttons */}
      <div className="interaction-options">

        {/* Voice Button */}
        <button
          onClick={handleVoiceStart}
          disabled={isListening}
          className={`glass-button voice-button ${isListening ? 'listening' : ''}`}
        >
          <div className="button-icon">
            {isListening ? <Volume2 size={48} /> : <Mic size={48} />}
          </div>
          <div className="button-text">
            {isListening ? 'Listening...' : 'Tell me what you want'}
          </div>
        </button>

        {/* Browse Menu Button */}
        <button
          onClick={onNext}
          className="glass-button menu-button"
        >
          <div className="button-icon">
            <Hand size={48} />
          </div>
          <div className="button-text">
            Browse Menu
          </div>
        </button>
      </div>

      {/* Footer */}
      <div className="welcome-footer">
        <p>Powered by GPT-OSS • Running Offline • Built for OpenAI Hackathon</p>
      </div>
    </div>
  );
};

export default WelcomeScreen;